import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { MatStepperIntl, MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { OnboardingRoutingModule } from './onboarding-routing.module';
import { OnboardingComponent } from './components/onboarding';
import { WelcomeComponent } from './components/welcome';

import { StepperIntl } from './utils/mat-stepper.intl';
import { OnboardingBeneficiosComponent } from './components/onboarding-beneficios';
import { OnboardingCardComponent } from './components/onboarding-card';
import { OnboardingEmpresaComponent } from './components/onboarding-empresa';
import { OnboardingCardPlaceholderComponent } from './components/onboarding-card-placeholder';
import { OnboardingContratoComponent } from './components/onboarding-contrato';
import { OnboardingBeneficiariosComponent } from './components/onboarding-beneficiarios';
import { SuperSmartComponent } from './components/super-smart';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { PipesModule } from '../../core/pipes/pipes.module';
import { LabelModule } from '../../core/pipes/label/label.module';
import { MatTableModule } from '@angular/material/table';
import { ModalConferenciaImportacaoComponent } from './components/modal-conferencia-importacao/modal-conferencia-importacao.component';

@NgModule({
  declarations: [
    OnboardingComponent,
    WelcomeComponent,
    OnboardingBeneficiosComponent,
    OnboardingCardComponent,
    OnboardingEmpresaComponent,
    OnboardingCardPlaceholderComponent,
    OnboardingContratoComponent,
    OnboardingBeneficiariosComponent,
    SuperSmartComponent,
    ModalConferenciaImportacaoComponent,
  ],
  providers: [
    {
      provide: MatStepperIntl,
      useClass: StepperIntl,
    },
    provideNgxMask(),
  ],
  imports: [
    CommonModule,
    OnboardingRoutingModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    MatStepperModule,
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    NgxMaskPipe,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    LabelModule,
    MatTableModule,
    MatProgressSpinnerModule,

    NgOptimizedImage,
  ],
})
export class OnboardingModule {}
